import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Subscription, of, Observable } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';

import { LoggingMessageService } from './logging-message.service';
import { DataResult } from '../models/data-result.mode';
import { SessionStorageService } from 'src/app/services/session-storage.service';


@Injectable({
    providedIn: 'root'
})
export class SubscriptionChangeService implements OnInit, OnDestroy {
    private $subscriptions: Subscription = new Subscription();
    private _NO_DATA = { message: '' };


    private _selectedSubscription: number;
    get SelectedSubscription(): number {
      return this._selectedSubscription;
    }
    set SelectedSubscription(value: number) {
      this._selectedSubscription = value;
    }

    private _availableSubscriptions: Array<number>;
    get AvailableSubscriptions(): Array<number> {
      return this._availableSubscriptions;
    }
    set AvailableSubscriptions(value: Array<number>) {
      this._availableSubscriptions = value;
    }

    get AvailableSubscriptionsString(): string {
        return this._availableSubscriptions.join(',');
    }

    constructor(private http: HttpClient, private logger: LoggingMessageService, private sessionService: SessionStorageService) {
        this.SelectedSubscription = 0;
        this.AvailableSubscriptions = new Array<number>();
    }

    ngOnInit(): void {

    }

    public changeSubscriptionId(service: string, subid: string, useTest: boolean): Observable<DataResult> {
        const webmethod = (useTest === true) ? '/SubscriptionTest' : '/Subscription';
        const media = 'application/json';
        // const media = 'text/plain';
        const id = Number(subid);
        const uri = `${service}${webmethod}`;
        const subscriptionModel = { subscriptionID: id, message: '' };

        this.logger.debug('SubscriptionChangeService', 'changeSubscriptionId', this.SelectedSubscription, this.AvailableSubscriptionsString, `calling url: ${uri}`, '');
        return this.http.post<DataResult>(uri, subscriptionModel,
            {
                headers: { Accept: media },
                observe: 'response'
            }
        )
            .pipe(
                map(response => {
                    let result: DataResult;
                    if (response instanceof HttpResponse) {
                        const respBody: any = response.body;
                        subscriptionModel.message = respBody.message;
                        subscriptionModel.subscriptionID = respBody.subscriptionID;
                        if (response.status === 200) {
                            result = new DataResult(response.ok, response.status, response.statusText, subscriptionModel);
                        } else if (response.status === 401) {
                            result = new DataResult(false, 401, response.statusText, subscriptionModel);
                        } else {
                            result = new DataResult(false, 400, response.statusText, subscriptionModel);
                        }
                    }
                    if (response instanceof HttpErrorResponse) {
                        subscriptionModel.message = response.message;
                        result = new DataResult(false, 500, response.statusText, subscriptionModel);
                    }
                    return result;
                }),
                catchError(error => {
                    this.logger.warn('SubscriptionChangeService', 'changeSubscriptionId', this.SelectedSubscription, this.AvailableSubscriptionsString, 'Error caught', '');
                    const message = this.getErrorMessage(error);
                    return this.handleChangeSubscriptionError(`changeSubscriptionId failed`, message);
                }),
                take(1),
            );
    }

    private getErrorMessage(error: any): string {
        let message = error.message;
        if ((error.error) && (error.error.message)) {
            message = error.error.message;
        }
        return message;
    }

    private handleChangeSubscriptionError(operation: string, error: any) {
        let result: any;
        const response = this._NO_DATA;
        this.logger.warn('product-change', 'handleChangeSubscriptionError', this.SelectedSubscription, this.AvailableSubscriptionsString, `Operation:${operation}`, `Server Error:${error}`);
        response.message = error;
        const errorResult = new DataResult(false, 503, 'Service Unavailable error', response);
        result = errorResult;

        return of(result);
    }

    unsubscribe() {
        if (this.$subscriptions) {
            this.$subscriptions.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }
}

